"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadedTerminals = exports.startedLoadingTerminals = void 0;
const initial_1 = __importDefault(require("@app/store/initial"));
const toolkit_1 = require("@reduxjs/toolkit");
/**
 * The workspace's terminals.
 *
 * In the store rather than in component state because the dashboard is remounted when the
 * terminal plugin is installed — `useRoutingConfig` rebuilds its route list from plugin
 * state — which orphans any callback holding a component's setState. The terminal-create
 * modal's success callback fires after exactly that remount, so it has to write somewhere
 * that outlives the component.
 */
const terminalsSlice = (0, toolkit_1.createSlice)({
    name: 'terminals',
    initialState: initial_1.default.terminals,
    reducers: {
        startedLoadingTerminals: (state, action) => {
            state.workspaceId = action.payload;
            state.list = null;
            state.isLoading = true;
        },
        loadedTerminals: (state, action) => {
            // A response for a workspace already navigated away from must not overwrite the
            // current one.
            if (state.workspaceId !== action.payload.workspaceId)
                return;
            state.list = action.payload.list;
            state.isLoading = false;
        },
    },
});
_a = terminalsSlice.actions, exports.startedLoadingTerminals = _a.startedLoadingTerminals, exports.loadedTerminals = _a.loadedTerminals;
exports.default = terminalsSlice.reducer;
